import React from 'react';

const styles = {
  card: {
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '24px',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1f2937',
    marginBottom: '16px',
  },
  insightsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  insightCard: {
    background: '#eff6ff',
    border: '1px solid #dbeafe',
    borderRadius: '8px',
    padding: '14px 18px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  icon: {
    fontSize: '20px',
    lineHeight: 1,
    flexShrink: 0,
    marginTop: '1px',
  },
  text: {
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#1e3a5f',
    fontWeight: 400,
  },
};

export default function InsightsPanel({ insights }) {
  if (!insights || insights.length === 0) {
    return (
      <div style={styles.card}>
        <div style={styles.title}>Key Insights</div>
        <div style={{ color: '#6b7280', textAlign: 'center', padding: '40px 0' }}>
          No insights generated yet
        </div>
      </div>
    );
  }

  return (
    <div style={styles.card}>
      <div style={styles.title}>Key Insights</div>
      <div style={styles.insightsList}>
        {insights.map((insight, idx) => (
          <div key={idx} style={styles.insightCard}>
            <span style={styles.icon}>{'\uD83D\uDCA1'}</span>
            <span style={styles.text}>{insight}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
